import { connect } from 'react-redux';

import HistoryLog from 'component/History';

import {
    newGame,
    checkSet,
} from 'actions/cards'

const mapStateToProps = state => ({
  historyLog: state.gameReducer.get('historyLog'),
});

const mapDispatchToProps = dispatch => ({
    newGame: () => {
        dispatch(newGame());
    },
    checkSet: (player) => {
        dispatch(checkSet(player));
    }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistoryLog);
